function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "test",
  transform: "translate(1.000000, 1.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.64258,11.6949 L2.64258,9.923 L11.9997,1.23432 L21.3569,9.923 L21.3569,11.6949 L21.3569,24.052 L2.64258,24.052 L2.64258,11.6949 Z M14.5,23.0521 L14.5,14.0965 C14.5,13.9141 14.3523,13.7664 14.1699,13.7664 L9.8301,13.7664 C9.6477,13.7664 9.5,13.9141 9.5,14.0965 L9.5,23.0521 L14.5,23.0521 Z",
  id: "Combined-Shape",
  stroke: "currentColor",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  stroke: "currentColor",
  fill: "currentColor",
  points: "17.2139 3.19482 19.6424 3.19482 19.6424 6.96671 17.2139 4.71178"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Path",
  fill: "currentColor",
  points: "0 11.6949 12 0.552 24 11.6949"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Path",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  points: "0 11.6949 12 0.552 24 11.6949"
})));

var SvgIcProductCatHousehold = function SvgIcProductCatHousehold(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcProductCatHousehold, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_product_cat_household.c3193d85.svg";
export { ForwardRef as ReactComponent };